import React, { useState } from "react";
import { Container, Col, Row } from "react-bootstrap/esm/index";

import "./NowApprovedNotification.scss";

export default function NowApprovedNotification() {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <React.Fragment>
      <div
        className={
          "notification now-approved-notification" +
          (!isOpen ? " notification-closed" : "")
        }
      >
        <Container>
          <Row>
            <Col>
              <div className="notification-inner">
                <div>
                  <img
                    className="notification-icon"
                    src="/images/icons/icon-now-approved@2x.png"
                    alt=""
                  />
                  <a href="/pediatric-itp/what-is-doptelet-for-children/">
                    Learn about a new and expanded indication
                  </a>
                </div>
                <div>
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    <img
                      className="notification-close"
                      src="/images/icons/icon-close-notification@2x.png"
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
